import App from './App.vue'
import router from './router'
import { createApp } from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import '@/interceptors/axios'
import VueMobileDetection from "vue-mobile-detection"
import { VueWindowSizePlugin } from 'vue-window-size/option-api';
import Vue3Sanitize from "vue-3-sanitize";
import {createHead} from '@vueuse/head'

const app = createApp(App).use(router);
app.use(VueAxios, axios);
app.use(VueMobileDetection);
app.use(VueWindowSizePlugin);
app.use(Vue3Sanitize);
app.use(createHead());
app.provide('axios', app.config.globalProperties.axios);
app.mount('#app');